export default "__VITE_ASSET__D0UbJ2DH__"